import React from 'react';
import { Landmark, ShieldCheck } from 'lucide-react';
import BankFileConfigurationCard from '../BankFileConfigurationCard';

const BankFilesTab = () => (
  <div className="space-y-6">
    <section
      aria-labelledby="bank-files-heading"
      className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm"
    >
      <div className="p-4 sm:p-6">
        <div className="flex items-start gap-3">
          <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-red-100">
            <Landmark className="h-5 w-5 text-red-600" />
          </div>
          <div className="min-w-0">
            <h2
              id="bank-files-heading"
              className="text-base font-semibold text-gray-900"
            >
              Payroll bank file providers
            </h2>
            <p className="mt-1 text-sm text-gray-600">
              Configure the company debit account used for Worker and Staff
              payment files generated in Payroll Step 4.
            </p>
          </div>
        </div>

        <div className="mt-4 flex items-start gap-2 rounded-xl border border-blue-200 bg-blue-50 p-3">
          <ShieldCheck className="mt-0.5 h-4 w-4 flex-shrink-0 text-blue-600" />
          <p className="text-xs text-blue-800">
            Only implemented bank formats appear here. UOB will become
            available after its supplied format passes implementation and
            validation.
          </p>
        </div>
      </div>
    </section>

    <BankFileConfigurationCard
      providerId="standard_chartered"
      providerName="Standard Chartered"
      formatLabel="Straight2Bank payroll CSV"
      defaultBic="SCBLSG22XXX"
      showAdvancedFields
    />

    <BankFileConfigurationCard
      providerId="ocbc"
      providerName="OCBC"
      formatLabel="GIRO/FAST WITH INV v1.6 payroll TXT"
      defaultBic="OCBCSGSGXXX"
    />
  </div>
);

export default BankFilesTab;
